import { useNavigate } from "react-router-dom";
import React from "react";
import { CreditorGroupHome } from "us.collection.admin/components/CreditorGroup";

const Cnt_NonProductionDaysHome: React.FC = (props) => {
  const navigate = useNavigate();

  const onMinimize = (state: any) => {
    navigate(`/bureau`, { state });
  };

  return <CreditorGroupHome onMinimize={onMinimize} {...props} />;
};

export default Cnt_NonProductionDaysHome;
